import { Component } from '@angular/core';

@Component({
  selector: 'app-patch-note',
  templateUrl: './patch-note.component.html',
  styleUrl: './patch-note.component.scss'
})
export class PatchNoteComponent {

}
